<template>
  <div class="page-pagination-wrapper">
    <div class="page-pagination">
      <button
        :disabled="currentPage === 1"
        :class="['page-pagination-arrow-btn', {'disabled': currentPage === 1}]"
        @click="changePage(false)"
      >
        <svg v-if="currentPage === 1" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M9.04961 12.0002C9.04961 12.1335 9.07028 12.2585 9.11161 12.3752C9.15294 12.4919 9.22394 12.6002 9.32461 12.7002L13.9246 17.3002C14.1079 17.4835 14.3413 17.5752 14.6246 17.5752C14.9079 17.5752 15.1413 17.4835 15.3246 17.3002C15.5079 17.1169 15.5996 16.8835 15.5996 16.6002C15.5996 16.3169 15.5079 16.0835 15.3246 15.9002L11.4246 12.0002L15.3246 8.1002C15.5079 7.91686 15.5996 7.68353 15.5996 7.4002C15.5996 7.11686 15.5079 6.88353 15.3246 6.7002C15.1413 6.51686 14.9079 6.42519 14.6246 6.42519C14.3413 6.42519 14.1079 6.51686 13.9246 6.7002L9.32461 11.3002C9.22461 11.4002 9.15361 11.5085 9.11161 11.6252C9.06961 11.7419 9.04894 11.8669 9.04961 12.0002Z" fill="#C1C3CB"/>
        </svg>
        <svg v-else xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M9.04961 12.0002C9.04961 12.1335 9.07028 12.2585 9.11161 12.3752C9.15294 12.4919 9.22394 12.6002 9.32461 12.7002L13.9246 17.3002C14.1079 17.4835 14.3413 17.5752 14.6246 17.5752C14.9079 17.5752 15.1413 17.4835 15.3246 17.3002C15.5079 17.1169 15.5996 16.8835 15.5996 16.6002C15.5996 16.3169 15.5079 16.0835 15.3246 15.9002L11.4246 12.0002L15.3246 8.1002C15.5079 7.91686 15.5996 7.68353 15.5996 7.4002C15.5996 7.11686 15.5079 6.88353 15.3246 6.7002C15.1413 6.51686 14.9079 6.42519 14.6246 6.42519C14.3413 6.42519 14.1079 6.51686 13.9246 6.7002L9.32461 11.3002C9.22461 11.4002 9.15361 11.5085 9.11161 11.6252C9.06961 11.7419 9.04894 11.8669 9.04961 12.0002Z" fill="black"/>
        </svg>
      </button>
      <div class="page-pagination-count">
        <input
          v-model="jumpPage"
          type="number"
          class="page-pagination-count-input"
          @keydown="jumpToPageInputHandler"
          @keyup.enter="jumpToPage"
        />
        <span v-if="props.lastPage" class="page-pagination-count-text">/{{ lastPage }}</span>
      </div>
      <button
        :disabled="currentPage === lastPage"
        :class="['page-pagination-arrow-btn', {'disabled': currentPage === lastPage}]"
        @click="changePage(true)"
      >
        <svg v-if="currentPage === lastPage" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M14.9504 12.0002C14.9504 12.1335 14.9297 12.2585 14.8884 12.3752C14.8471 12.4919 14.7761 12.6002 14.6754 12.7002L10.0754 17.3002C9.89206 17.4835 9.65872 17.5752 9.37539 17.5752C9.09206 17.5752 8.85872 17.4835 8.67539 17.3002C8.49206 17.1169 8.40039 16.8835 8.40039 16.6002C8.40039 16.3169 8.49206 16.0835 8.67539 15.9002L12.5754 12.0002L8.67539 8.1002C8.49206 7.91686 8.40039 7.68353 8.40039 7.4002C8.40039 7.11686 8.49206 6.88353 8.67539 6.7002C8.85872 6.51686 9.09206 6.42519 9.37539 6.42519C9.65872 6.42519 9.89206 6.51686 10.0754 6.7002L14.6754 11.3002C14.7754 11.4002 14.8464 11.5085 14.8884 11.6252C14.9304 11.7419 14.9511 11.8669 14.9504 12.0002Z" fill="#C1C3CB"/>
        </svg>
        <svg v-else xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M14.9504 12.0002C14.9504 12.1335 14.9297 12.2585 14.8884 12.3752C14.8471 12.4919 14.7761 12.6002 14.6754 12.7002L10.0754 17.3002C9.89206 17.4835 9.65872 17.5752 9.37539 17.5752C9.09206 17.5752 8.85872 17.4835 8.67539 17.3002C8.49206 17.1169 8.40039 16.8835 8.40039 16.6002C8.40039 16.3169 8.49206 16.0835 8.67539 15.9002L12.5754 12.0002L8.67539 8.1002C8.49206 7.91686 8.40039 7.68353 8.40039 7.4002C8.40039 7.11686 8.49206 6.88353 8.67539 6.7002C8.85872 6.51686 9.09206 6.42519 9.37539 6.42519C9.65872 6.42519 9.89206 6.51686 10.0754 6.7002L14.6754 11.3002C14.7754 11.4002 14.8464 11.5085 14.8884 11.6252C14.9304 11.7419 14.9511 11.8669 14.9504 12.0002Z" fill="black"/>
        </svg>
      </button>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref, watch } from "vue";

const props = defineProps({
  currentPage: {
    type: Number,
    required: true,
  },
  lastPage: {
    type: Number,
    required: false,
  },
  onPageChange: {
    type: Function,
    required: true,
  },
});
const jumpPage = ref(null);

onMounted(() => {
  jumpPage.value = props.currentPage;
});

watch(props, () => {
  jumpPage.value = props.currentPage;
});

const changePage = (isNext) => {
  const page = isNext ? props.currentPage + 1 : props.currentPage - 1;
  jumpPage.value = page;
  props.onPageChange(page);
};

const jumpToPage = () => {
  let value = Number(jumpPage.value);
  const { onPageChange, currentPage, lastPage } = props;
  value = value > lastPage ? lastPage : value < 1 ? 1 : value;
  if (value !== currentPage) {
    jumpPage.value = value;
    onPageChange(value);
  } else {
    jumpPage.value = value;
  }
};

const jumpToPageInputHandler = (e) => {
  const { key } = e;
  if (key === "." || key === ",") {
    e.preventDefault();
  }
};
</script>

<style lang="scss" scoped>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input[type=number] {
  -moz-appearance:textfield;
}
.page-pagination-wrapper {
  position: sticky;
  bottom: 1.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
.page-pagination {
  * + * {
    margin-top: 0;
  }
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  border-radius: 4px;
  border: 1px solid #c1c3cb;
  background: #fff;
  box-shadow: 0px -2px 16px 0px rgba(60, 75, 93, 0.08);
  padding: 8px;
  &-arrow-btn {
    padding: 0;
    background: white;
    height: 24px;
    width: 24px;
    transition: 0.2s ease-in-out;
    &:hover{
      background: #E9F0FD;
    }
    &.disabled{
      &:hover{
        background: white;
      }
    }
  }
  &-count{
    display: flex;
    align-items: center;
    gap: 8px;
    &-input{
      width: 40px;
      height: 26px;
      color: #000;
      text-align: center;
      border-radius: 4px;
      border: 1px solid #C1C3CB;
      font-size: 18px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      transition: 0.2s ease-in-out;
      &:hover{
        border: 1px solid #606266;
      }
      &:active{
        border: 1px solid #000;
      }
    }
    &-text {
      color: #606266;
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      letter-spacing: 0.5px;
    }
  }

}
</style>